/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { TableRow, TableCell, Grid, Paper } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  Modal,
  Loading,
} from "App/Component/ui";
import { FORM_FILTER_DOKTER } from "App/Component/layout/Manajemen/Dokter/utils";
import {
  instance3,
  STYLE_DEFAULT_MASTER,
  TYPE_PAGINATION_DOUBLE_ROWS,
} from "App/constants";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { SelectIcon, TrashIcon } from "App/Assets";
import FormFilterDokter from "App/Component/layout/Manajemen/Dokter/FormFilterDokter";
import { FreezeTable, FreezeTableClient } from "components/organism";

export default function ModalJasaDokter({ setShowModal, jasaID }) {
  const [rows, setRows] = useState([]);

  const setNewData = async () => {
    const res = await getJasaDokterByMsJasa(jasaID);
    if (res.state) {
      setRows(res.data);
    }
  };

  const handleClickSelect = async (row) => {
    try {
      const api = await instance3.post(`/master/jasa/jasa_dokter/register`, {
        id_jasa: jasaID,
        id_dokter: row.id,
        remark: "-",
      });

      const res = api.data;
      if (res.status === 200) {
        await setNewData();
        defaultToastSuccess("Berhasil menambah dokter pada jasa ini");
      } else {
        defaultToastError(res.message);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickDelete = async (row) => {
    try {
      const api = await instance3.post(`/master/jasa/jasa_dokter/delete`, {
        id: row.id,
      });

      const res = api.data;
      if (res.status === 200) {
        await setNewData();
        defaultToastSuccess("Berhasil mengahapus dokter pada jasa ini");
      } else {
        defaultToastError(res.message);
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []);

  return (
    <Modal title='Jasa Dokter' width={"60%"} show={setShowModal}>
      <Grid container spacing={2}>
        <Grid item sm={6}>
          <DokterList
            handleClickSelect={handleClickSelect}
            jasaID={jasaID}
            lengthDokterJasaList={rows.length}
          />
        </Grid>
        <Grid item sm={6}>
          <DokterJasaList rows={rows} handleClickDelete={handleClickDelete} />
        </Grid>
      </Grid>
    </Modal>
  );
}

export const getJasaDokterByMsJasa = async (id) => {
  try {
    const api = await instance3.get(
      `/master/jasa/jasa_dokter/listDokterByMs_Jasa/${id}`
    );
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

const DokterJasaList = ({ rows, handleClickDelete }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id", "nama_dokter"],
  });

  return (
    <FreezeTableClient
      title='Daftar Jasa Dokter'
      maxHeight='400px'
      setQ={setQ}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCells}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return (
            <TableRow hover tabIndex={-1} key={index}>
              <TableCell scope='row' padding='none' width='5%' align='center'>
                {index + 1}
              </TableCell>

              <TableCell scope='row' align='left' padding='none' width='5%'>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}>
                  <IconButtonDatatable onClick={() => handleClickDelete(row)}>
                    <TrashIcon />
                  </IconButtonDatatable>
                </div>
              </TableCell>

              <TableCell align='left'>{row.nama_dokter}</TableCell>
              <TableCell align='left'>{row?.masterJasa}</TableCell>
            </TableRow>
          );
        })}
    </FreezeTableClient>
  );
};

const DokterList = ({ handleClickSelect, jasaID, lengthDokterJasaList }) => {
  const classes = STYLE_DEFAULT_MASTER();

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState({
    ...FORM_FILTER_DOKTER,
    id_jasa: jasaID,
  });
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, [lengthDokterJasaList]);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getAllDokter(
      formFilter,
      pages,
      limit,
      "/master/jasa/jasa_dokter/list-dokter-not-injasa"
    );
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "fullname",
    orderByRow: ["fullname"],
  });

  return (
    <Paper
      className={classes.paper}
      style={{
        padding: "1rem",
      }}>
      <Loading show={loading} />

      <div className='mb-1'>
        <FormFilterDokter
          onlyName={true}
          formFilter={formFilter}
          setFormFilter={setFormFilter}
          setNewData={setNewData}
        />
      </div>

      <FreezeTable
        headCells={headCellsDokterList}
        maxHeight='400px'
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}>
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <TableRow hover key={index}>
              <TableCell scope='row' padding='none' align='center'>
                {index + 1}
              </TableCell>

              <TableCell scope='row' width='5%' padding='none' align='center'>
                <IconButtonDatatable
                  onClick={() => handleClickSelect(row)}
                  color='secondary'
                  aria-label='delete'
                  style={{
                    background: "#D8D8D8",
                    borderRadius: "8px",
                    padding: "6px",
                  }}>
                  <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                </IconButtonDatatable>
              </TableCell>

              <TableCell align='left'>{row.fullname}</TableCell>
            </TableRow>
          );
        })}
        {rows.length === 0 && (
          <TableRow>
            <TableCell align='center' colSpan={3}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>

      <DatatablesFooterServerSide
        totalData={totalData}
        typePagination={TYPE_PAGINATION_DOUBLE_ROWS}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={pagination.page}
        handleClickPageNumber={handleClickPageNumber}
      />
    </Paper>
  );
};

export const headCellsDokterList = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "fullname",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
];

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "dokter_name",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "masterJasa",
    disablePadding: false,
    label: "JASA",
    align: "left",
    minWidth: "150px",
  },
];

export const getAllDokter = async (
  formFilter,
  pages,
  limit,
  url = "/doctor/listdoctor"
) => {
  try {
    const api = await instance3.get(url, {
      headers: {
        name: formFilter.name,
        poliklinik_id: formFilter.poliklinik_id,
        spec_code: formFilter.spec_code,
        hospital_code: formFilter.hospital_code,
        id_jasa: formFilter?.id_jasa,
        pages,
        limit,
      },
    });
    const res = api.data;
    return {
      state: true,
      data: res.body,
      meta: res?.meta,
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};
